// extracted by mini-css-extract-plugin
module.exports = {"s1juw2ce":"s1juw2ce","so8ast9":"so8ast9","s1c0sl9k":"s1c0sl9k"};